import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

const dataCenterValues = [
  { icon: 'ri-file-text-line', title: 'Belgeleri Hızla Analiz Edin', desc: 'PDF, DOCX, TXT veya HTML dosyalarını yükleyin; anında özetler ve eyleme geçirilebilir içgörüler elde edin.' },
  { icon: 'ri-code-s-slash-line', title: 'Özel Kodu Denetleyin', desc: 'Dahili kod tabanlarını harici olarak açıklamadan hızlıca inceleyin ve optimize edin.' },
  { icon: 'ri-settings-4-line', title: 'Altyapı Görevlerini Otomatikleştirin', desc: 'VergeOS\'u aşan altyapı yönetimini otomatikleştirmek ve basitleştirmek için doğru betikler oluşturun.' },
];

const enterpriseValues = [
  { icon: 'ri-article-line', title: 'İçerik Üretin', desc: 'Güvenli veri setlerinizden verimli şekilde belgeler, bilgi makaleleri ve politikalar oluşturun.' },
  { icon: 'ri-line-chart-line', title: 'Gerçek Zamanlı Altyapı İçgörüleri', desc: 'Anlık, eyleme geçirilebilir operasyonel veriler ve içgörüler için altyapınızı sorgulayın.' },
  { icon: 'ri-check-double-line', title: 'Bir Yükleme, Üç Sorunu Çözer', desc: 'Eski altyapıdan çıkın, Altyapıyı Modernize Edin ve yapay zekayı kuruluşa sunun. Kendi hızınızda, hepsi bir seferde veya birer birer.' },
];

const whyPoints = [
  {
    icon: 'ri-timer-flash-line',
    title: 'Anlık Kullanılabilirlik',
    desc: 'VergeOS\'un bir parçası olarak otomatik olarak dağıtılır; karmaşık yapılandırma veya eğitim olmaksızın güvenli üretken yapay zeka ortamları sunar.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Esnek, Satıcıdan Bağımsız Altyapı',
    desc: 'Herhangi bir standart GPU donanımı ve LLaMA, Qwen, Phi, Gemma gibi popüler büyük dil modellerinden yararlanın; satıcı kilitleme ve maliyetleri azaltın.',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Optimize Edilmiş Kaynak Yönetimi',
    desc: 'Akıllı GPU havuzlama ve dinamik kaynak tahsisi neredeyse çıplak donanım performansı sağlar; altyapı verimliliğini ve ölçeklenebilirliği artırır.',
  },
];

const faqList = [
  {
    q: 'VergeIQ nedir?',
    a: 'VergeIQ, VergeOS\'a entegre yapay zeka çözümüdür. Tıpkı VergeFS (depolama) ve VergeFabric (ağ) gibi yapay zekayı VergeOS içinde yerel bir kaynak haline getirir. Kuruluşların özel yapılandırma veya eğitim gerektirmeksizin tamamen özel, on-premises üretken yapay zeka ortamlarından yararlanmasına olanak tanır.',
  },
  {
    q: 'VergeIQ hangi yapay zeka modellerini destekler?',
    a: 'VergeIQ, LLaMA, Qwen, Phi, Gemma dahil herhangi bir standart GPU donanımı ve popüler büyük dil modelleri ile çalışır. Satıcı bağımsız yaklaşımı, hem mevcut hem de gelecekteki modellere uyarlanabilir bir altyapı sağlar.',
  },
  {
    q: 'VergeIQ OpenAI gibi bulut tabanlı yapay zeka servislerinden nasıl farklıdır?',
    a: 'VergeIQ tamamen on-premises çalışır. Hassas belgeler, özel kod veya dahili verileri harici servislere göndermeden analiz edebilirsiniz. Tam veri gizliliği ve kontrol şirkette kalır.',
  },
  {
    q: 'VergeIQ nasıl dağıtılır?',
    a: 'VergeIQ, VergeOS kurulumunun bir parçası olarak otomatik olarak dağıtılır. Ayrı kurulum, lisanslama veya yapılandırma gerekmez. VergeOS çalışıyorsa VergeIQ hazırdır.',
  },
];

const vergeiqFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'VergeIQ nedir?', acceptedAnswer: { '@type': 'Answer', text: "VergeIQ, VergeOS'a entegre yapay zeka çözümüdür. Tıpkı VergeFS ve VergeFabric gibi yapay zekayı VergeOS içinde yerel bir kaynak haline getirir." } },
    { '@type': 'Question', name: 'VergeIQ hangi yapay zeka modellerini destekler?', acceptedAnswer: { '@type': 'Answer', text: 'VergeIQ, LLaMA, Qwen, Phi, Gemma dahil herhangi bir standart GPU donanımı ve popüler büyük dil modelleri ile çalışır.' } },
    { '@type': 'Question', name: "VergeIQ OpenAI gibi bulut tabanlı yapay zeka servislerinden nasıl farklıdır?", acceptedAnswer: { '@type': 'Answer', text: 'VergeIQ tamamen on-premises çalışır. Hassas belgeler, özel kod veya dahili verileri harici servislere göndermeden analiz edebilirsiniz.' } },
    { '@type': 'Question', name: 'VergeIQ nasıl dağıtılır?', acceptedAnswer: { '@type': 'Answer', text: "VergeIQ, VergeOS kurulumunun bir parçası olarak otomatik olarak dağıtılır. Ayrı kurulum, lisanslama veya yapılandırma gerekmez." } },
  ],
};

const vergeiqAppJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeIQ',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeOS entegre on-premises yapay zeka. LLaMA, Qwen, Phi, Gemma desteği ile tam veri gizliliği ve güvenlik.',
  url: `${SITE_URL}/vergeiq`,
};

export default function VergeIQPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="VergeIQ | On-Premises Yapay Zeka Entegrasyonu | VergeOS"
        description="VergeIQ ile VergeOS altyapınıza entegre özel yapay zeka. LLaMA, Qwen, Phi, Gemma desteği. Tam veri gizliliği, harici servise ihtiyaç yok, on-premises AI."
        keywords="VergeIQ, on-premises AI, yapay zeka altyapı, private AI, LLM, VergeOS, güvenli yapay zeka"
        canonicalPath="/vergeiq"
        jsonLd={[vergeiqAppJsonLd, vergeiqFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
              Mimari · Yapay Zeka
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">VergeIQ:</span> Her İşletme İçin<br />Yerinde Yapay Zeka
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">
              Tek Bir Yazılım Çözümünde Özel, Üretken Yapay Zeka
            </p>
          </div>
        </section>

        {/* Secure AI Intro */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/b6355f7cd12a4d9043128a9acfc80660.jpg"
                  alt="VergeIQ Güvenli Yapay Zeka"
                  className="w-full h-full object-top"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">VergeOS'a Entegre Güvenli, Özel Yapay Zeka</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  VergeIQ, tıpkı depolama (VergeFS) ve ağ (VergeFabric) gibi <strong className="text-[#1e293b]">yapay zekayı VergeOS içinde yerel bir kaynak</strong> haline getirir. Kuruluşların çekirdek altyapılarından bekledikleri sadelik, verimlilik ve kontrol ile tamamen özel, on-premises üretken yapay zeka ortamlarından yararlanmasına olanak tanır.
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  VergeIQ, hassas belgeler, özel kod ve dahili veriler üzerinde tam kontrolü kuruluşta tutarak anlık içgörüler, özelleştirilmiş içerik ve eyleme geçirilebilir istihbarat üretmenize olanak tanır.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What Can You Do */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">VergeIQ ile Neler Yapabilirsiniz?</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm leading-relaxed">
                VergeIQ, işletmenizin kendi güvenli altyapınız içinde özel yapay zeka yeteneklerini kullanmasına olanak tanır. <strong>VergeOS kurulumunun birkaç dakikası içinde</strong>, tam veri gizliliği ve kontrolü koruyarak pratik, eyleme geçirilebilir içgörüler kazanacaksınız.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h3 className="font-bold text-[#1e293b] text-lg mb-6 pb-3 border-b border-gray-200">
                  <i className="ri-server-line text-[#e8600a] mr-2"></i>
                  Veri Merkezi için Değer
                </h3>
                <div className="space-y-5">
                  {dataCenterValues.map((v) => (
                    <div key={v.title} className="flex gap-4">
                      <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0">
                        <i className={`${v.icon} text-xl`}></i>
                      </span>
                      <div>
                        <p className="font-semibold text-[#1e293b] mb-1 text-sm">{v.title}</p>
                        <p className="text-xs text-gray-600 leading-relaxed">{v.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="font-bold text-[#1e293b] text-lg mb-6 pb-3 border-b border-gray-200">
                  <i className="ri-building-2-line text-[#e8600a] mr-2"></i>
                  Kuruluş için Değer
                </h3>
                <div className="space-y-5">
                  {enterpriseValues.map((v) => (
                    <div key={v.title} className="flex gap-4">
                      <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0">
                        <i className={`${v.icon} text-xl`}></i>
                      </span>
                      <div>
                        <p className="font-semibold text-[#1e293b] mb-1 text-sm">{v.title}</p>
                        <p className="text-xs text-gray-600 leading-relaxed">{v.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Architecture Diagram */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=enterprise%20AI%20architecture%20diagram%20showing%20private%20on-premises%20AI%20system%20integrated%20with%20virtual%20data%20center%20storage%20network%20and%20legacy%20virtualization%20layers%2C%20VergeIQ%20replacing%20legacy%20AI%20infrastructure%20diagram%20with%20OpenAI%20alternative%2C%20orange%20accent%20technical%20diagram%20dark%20background%20professional%20visualization&width=580&height=420&seq=vergeiq_arch1&orientation=landscape"
                  alt="VergeIQ Mimari Diyagramı"
                  className="w-full h-full object-top"
                />
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=VergeOS%20enterprise%20AI%20dashboard%20showing%20multiple%20virtual%20machines%20with%20AI%20capabilities%20running%20on%20unified%20infrastructure%20platform%2C%20modern%20dark%20UI%20with%20orange%20accents%20showing%20AI%20workload%20management%20alongside%20VM%20storage%20and%20network%20resources%20management&width=580&height=420&seq=vergeiq_dash1&orientation=landscape"
                  alt="VergeIQ Yönetim Arayüzü"
                  className="w-full h-full object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why VergeIQ */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">Neden On-Premises Yapay Zeka İçin VergeIQ?</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm leading-relaxed">
                VergeIQ, özel üretken yapay zeka yeteneklerini sorunsuz bir alternatifle benzersiz biçimde birleştirir; hepsi kendi veri merkezinizde. Açıkça altyapı yönetimini basitleştirmek, kaynak verimliliğini artırmak ve tam güvenlik ile uyumluluğu sağlamak için tasarlanmıştır.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {whyPoints.map((p) => (
                <div key={p.title} className="bg-white rounded-lg border border-gray-100 p-6">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#0f1117] rounded-lg text-[#e8600a] mb-4">
                    <i className={`${p.icon} text-2xl`}></i>
                  </span>
                  <h3 className="font-semibold text-[#1e293b] mb-2">{p.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Schedule CTA */}
        <section className="py-16 bg-[#0f1117]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">VergeIQ Teknik Derinlemesine Sunum Planlayın</h2>
            <p className="text-gray-400 mb-8 text-sm leading-relaxed">
              VergeIQ\'nun yapay zekayı doğrudan VergeOS altyapınıza nasıl yerleştirdiğini, desteklenen modelleri ve kuruluşunuz için pratik kullanım senaryolarını keşfetmek için uzmanlarımızla görüşün.
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">VergeIQ SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0">
                      <i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                    </span>
                  </button>
                  {openFaq === i && (
                    <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
